import _ from 'underscore';

export class SubplaceEvents {
  public static Refresh = 'Refresh';
  public static RefreshCounts = 'RefreshCounts';
}

// TODO: Combine the following into a single SubplaceHelper.

export interface ISubplaceTabsScope extends ng.IScope {
  subplaceTabClicked: (name: string) => void;
  // Following two functions are used for react-router-powered pages
  isSelectedTab: (name: string) => boolean;
  getTabUrl: (name: string) => string;
}

export interface ISubplaceCountsScope extends ng.IScope {
  subplaceCounts: _.Dictionary<number>;
}
